/*
 * fn: getComboBracketStatus
 *
 * Returns the combo's bracket info for one bracket: the low tier for 1-2, the mid tier for 3, always valid for 4-5
 *
 */
import { type ComboBracketType, type ComboPreviewType } from '@/defs/combo'
import { type FilterBracketType } from '@/defs/filters'

type Props = {
  bracket: FilterBracketType
  combo: Pick<ComboPreviewType, 'bracketInfo'>
}

const BRACKET_INFO_VALID: ComboBracketType = {
  message: 'All combos are allowed.',
  status: 'valid',
}

export const getComboBracketStatus = ({ bracket, combo }: Props): ComboBracketType => {
  const CONFIG: Record<FilterBracketType, ComboBracketType> = {
    cedh: BRACKET_INFO_VALID,
    core: combo.bracketInfo.low,
    exhibition: combo.bracketInfo.low,
    optimized: BRACKET_INFO_VALID,
    upgraded: combo.bracketInfo.mid,
  }

  return CONFIG[bracket]
}
